/* eslint-disable */
import React from 'react';
import mapContext from '../contexts/map-context';
import { ActionTypes } from '../contexts/reducers/map-reducer';
import { getServices } from '../utils/search';
import useSearchByGeoArea from './useSearchByGeoArea';
import type { Dealer } from '../models/dealer';
import { trackSearchByZipCodeQuery } from '../utils/trackingUtils';
import trackingContext from '../contexts/tracking-context';
import { getActiveFilters } from '../utils/activeFilters';

export default function useResultsByGeoArea() {
  const { trackingService: tService } = trackingContext.useTrackingState();
  const dispatch = mapContext.useMapDispatch();
  const {
    northEastPosition,
    southWestPosition,
    userSelectedFilters,
    preselectedFilters,
    locale,
    intlSearchEnabled,
    userGeolocation,
    query,
  } = mapContext.useMapState();

  const activeFilters = getActiveFilters(preselectedFilters, userSelectedFilters);

  const { loading, error, dealersResult } = useSearchByGeoArea(
    northEastPosition,
    southWestPosition,
    intlSearchEnabled ? undefined : locale.countryCode,
    activeFilters,
    userGeolocation?.lat,
    userGeolocation?.lng,
  );
  const dispatchSuccessfulQueries = (dealers: Dealer[]) => {
    dispatch({
      type: ActionTypes.setLoading,
      payload: false,
    });
    dispatch({
      type: ActionTypes.setSearchError,
      payload: null,
    });
    dispatch({
      type: ActionTypes.setResults,
      payload: { dealers, services: getServices(dealers) },
    });
    dispatch({
      type: ActionTypes.setSelectedPartner,
      payload: { tenant: dealers[0]?.country, kvpsid: dealers[0]?.kvpsId },
    });
    dispatch({ type: ActionTypes.setShowRadius, payload: false });
    trackSearchByZipCodeQuery(
      tService,
      query,
      dealersResult?.length || 0,
      activeFilters,
      dealersResult || [],
    );
  };

  React.useEffect(() => {
    if (error) {
      dispatch({
        type: ActionTypes.setSearchError,
        payload: error,
      });
    }
  }, [error]);

  React.useEffect(() => {
    if (loading) {
      dispatch({
        type: ActionTypes.setLoading,
        payload: true,
      });
      dispatch({ type: ActionTypes.setSearchRadiusExtended, payload: false });
    }
  }, [loading]);

  React.useEffect(() => {
    if (dealersResult) {
      dispatchSuccessfulQueries(dealersResult);
    }
  }, [dealersResult]);
}
